import React from 'react';
import {ContainerBox, BackIcon, Title, SubTitle, BackBtn, ContinueBtn, ChosenImagesTitle} from '../Style/ManualRefinementReferenceDisplay.style';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import ReferenceDisplay from './ReferenceDisplay.view';
import {IProps} from '../Config/ManualRefinementReferenceDisplay.types';
import useManualRefinementImageList from '../../ManualRefinementImageList/Controller/useManualRefinementImageList.controller';


const ManualRefinementReferenceDisplay = ({goBack, manualRefinementState, setState}:IProps) => {
    const {getNumberOfApprovedImages} = useManualRefinementImageList(manualRefinementState, setState);

    return (
        <ContainerBox>

            <BackBtn onClick={() => goBack && goBack()} startIcon={<BackIcon/>} size='small'>{_SYSTEM_TITLES.backToProjectBtn}</BackBtn>
            <Title>{_SYSTEM_TITLES.manualRefinementTitle}</Title>
            <SubTitle>{_SYSTEM_TITLES.manualRefinementSubTitle}</SubTitle>
            <ReferenceDisplay manualRefinementState={manualRefinementState}/>
            {getNumberOfApprovedImages() > 0 ? <ChosenImagesTitle>{_SYSTEM_TITLES.manualRefinementCounterTitle + getNumberOfApprovedImages()}</ChosenImagesTitle> : null}
            <ContinueBtn onClick={() => setState({isMoveToAnotherClass: true})} size='large'>Confirm & Continue</ContinueBtn>

        </ContainerBox>
    );

};

export default ManualRefinementReferenceDisplay;
